<ion-row role="region" aria-label="Content section">
	<ion-col class="ion-no-padding">
		<ion-card>
			<ion-card-content>
				<ion-row role="region" aria-label="Content container">
					<ion-col size="12" class="reorder-section">
						<div class="reorder" (click)="reorder()" role="button" tabindex="0">
							{{ 'my_order.reorder' | translate }}
						</div>
					</ion-col>
				</ion-row>
				<ion-row class="ion-align-items-center">
					<ion-col class="header" size="12"> {{ 'payment_success_page.overview' | translate }} {{ order.code }} </ion-col>
				</ion-row>
			</ion-card-content>
			<ion-card-content *ngIf="order?.status !== os.DONE && order?.preorder?.type == pt.DELIVERY">
				<ion-row role="region" aria-label="Content section">
					<ion-col size="12">
						<div class="delivery-info" role="region" aria-label="Delivery information">
							<h3>Order delivery info</h3>
							<div class="btn" (click)="checkDelivery(order)" role="button" tabindex="0">Check status</div>
						</div>
					</ion-col>
				</ion-row>
			</ion-card-content>
			<ion-card-content>
				<ion-row>
					<ion-col>
						<h3>{{ 'payment_success_page.order_number' | translate }}</h3>
					</ion-col>
					<ion-col class="flex">
						{{ order.code }}
					</ion-col>
				</ion-row>
				<ion-row>
					<ion-col>
						<h3>{{ 'payment_success_page.order_type' | translate }}</h3>
					</ion-col>
					<ion-col class="flex">
						{{ order.preorder.type }}
					</ion-col>
				</ion-row>
				<ion-row *ngIf="!showMinInfo" role="region" aria-label="Additional information">
					<ion-col>
						<h3>{{ 'payment_success_page.date_time' | translate }}</h3>
					</ion-col>
					<ion-col>
						{{ moment(order.orderAt).format('HH:mm / DD.MM.yyyy') }}
					</ion-col>
				</ion-row>

				<ion-row *ngIf="!showMinInfo" role="region" aria-label="Additional information row">
					<ion-col>
						<h3>{{ 'payment_success_page.name' | translate }}</h3>
					</ion-col>
					<ion-col>
						{{ order.preorder.name }}
					</ion-col>
				</ion-row>
				<ion-row *ngIf="!showMinInfo" role="region" aria-label="Detailed information row">
					<ion-col>
						<h3>{{ 'payment_success_page.email' | translate }}</h3>
					</ion-col>
					<ion-col>
						{{ order.preorder.email }}
					</ion-col>
				</ion-row>
				<ion-row *ngIf="!showMinInfo" role="region" aria-label="Detailed information row">
					<ion-col>
						<h3>{{ 'payment_success_page.phone' | translate }}</h3>
					</ion-col>
					<ion-col> +{{ order.preorder.phone }} </ion-col>
				</ion-row>
				<ion-row *ngIf="!showMinInfo" role="region" aria-label="Information section">
					<ion-col>
						<h3>{{ 'payment_success_page.payment_method' | translate }}</h3>
					</ion-col>
					<ion-col>
						{{ order.method | translate }}
					</ion-col>
				</ion-row>
			</ion-card-content>

			<ion-card-content>
				<ion-row *ngFor="let oa of order.orderedArticles" role="region" aria-label="Ordered articles list item">
					<ion-col size="8">
						<h3>{{ oa.article.name | langObservable | async }} x{{ oa.quantity }}</h3>
						<div *ngFor="let option of oa.groups" role="region" aria-label="Option group">
							{{ option.article.name | langString }}
						</div>
					</ion-col>
					<ion-col size="4">
						<b>
							{{ numberToCurrency(OrderUtils.totalPrice(oa, order.type, order.preorder.type), order.currency) }}
						</b>
					</ion-col>
				</ion-row>

				<ion-row *ngIf="order.preorder.note && order.preorder.note.length > 0" role="region" aria-label="Order preorder note">
					<ion-col size="8">
						<h3>{{ 'payment_success_page.note' | translate }}</h3>
					</ion-col>
					<ion-col size="4">{{ order.preorder.note }}</ion-col>
				</ion-row>
			</ion-card-content>

			<ion-card-content>
				<ion-row class="header">
					<ion-col size="8">
						<h3>{{ 'payment_success_page.summary' | translate }}</h3>
					</ion-col>
					<ion-col size="4">
						<h3 class="right-col">{{ OrderUtils.formattedOrderTotalPrice(order, true, true) }}</h3>
					</ion-col>
				</ion-row>
			</ion-card-content>
		</ion-card>
	</ion-col>
</ion-row>
